const webhookData = {
  title: 'Webhooks',
  type: 'Webhook',
  steps: [{ title: 'Configuration' }, { title: 'Payload & Headers' }, { title: 'Test & Settings' }],
};

export const WEBHOOK_INTEGRATION_TYPE = 'ctaWebhook';

export const WEBHOOK_BODY_TYPES = {
  JSON: 'json',
  FORM_URLENCODED: 'x-www-form-urlencoded',
};

export const WEBHOOK_FIELD_DATA_TYPES = {
  CTA: 'cta',
  ENRICHMENT: 'enrichment',
};

export const WEBHOOK_INTEGRATION_FIELD_TYPES = [
  { label: 'Static Value', value: 'static' },
  { label: 'Other CTA', value: 'other_cta' },
  // UI-only variant: still stored as type "other_cta"
  { label: 'User Input CTA', value: 'other_cta_agent' },
  { label: 'Session Metadata', value: 'sessionMetadata' },
  { label: 'Action Take Data', value: 'actionTakeData' },
  { label: 'User Questions', value: 'kaConversation' },
  { label: 'Poll Answer', value: 'engagements' },
];

export const WEBHOOK_SESSION_METADATA_QUERY_PARAMS_PREFIX = 'sessionDetails.queryParams';

export const WEBHOOK_SESSION_METADATA_KEY_OPTIONS = [
  { label: 'Origin', value: 'sessionDetails.origin' },
  { label: 'Agent ID', value: 'campaign' },
  { label: 'Query Params', value: WEBHOOK_SESSION_METADATA_QUERY_PARAMS_PREFIX },
];

export const isSessionMetadataQueryParamsKey = key =>
  key === WEBHOOK_SESSION_METADATA_QUERY_PARAMS_PREFIX ||
  key?.startsWith(`${WEBHOOK_SESSION_METADATA_QUERY_PARAMS_PREFIX}.`);

export const getSessionMetadataSelectValue = key => {
  if (!key) return undefined;
  // Legacy value from earlier Origin mapping
  if (key === 'origin') return 'sessionDetails.origin';
  if (isSessionMetadataQueryParamsKey(key)) return WEBHOOK_SESSION_METADATA_QUERY_PARAMS_PREFIX;
  return key;
};

export const getSessionMetadataQueryParamName = key => {
  if (!key?.startsWith(`${WEBHOOK_SESSION_METADATA_QUERY_PARAMS_PREFIX}.`)) return '';
  return key.slice(WEBHOOK_SESSION_METADATA_QUERY_PARAMS_PREFIX.length + 1);
};

export const buildSessionMetadataQueryParamsKey = paramName =>
  `${WEBHOOK_SESSION_METADATA_QUERY_PARAMS_PREFIX}.${paramName || ''}`;

export const WEBHOOK_ACTION_TAKE_DATA_KEY_OPTIONS = [
  { label: 'reCAPTCHA Token', value: 'recaptchaToken' },
];

export const WEBHOOK_FIELD_SOURCES = {
  CTA: 'cta',
  ENRICHMENT: 'enrichment',
};

export const CONTENT_TYPE_BY_BODY_TYPE = {
  [WEBHOOK_BODY_TYPES.JSON]: 'application/json',
  [WEBHOOK_BODY_TYPES.FORM_URLENCODED]: 'application/x-www-form-urlencoded',
};

export const SYSTEM_VARIABLE_NAMES = new Set([
  'bridged_visitor_id',
  'bridged_session_id',
  'bridged_agent_id',
  'bridged_cta_id',
  'timestamp',
  'source',
]);

export const DEFAULT_PAYLOAD_FIELDS = [
  { fieldId: '', key: 'first_name', dataType: WEBHOOK_FIELD_DATA_TYPES.CTA },
  { fieldId: '', key: 'last_name', dataType: WEBHOOK_FIELD_DATA_TYPES.CTA },
  { fieldId: '', key: 'email', dataType: WEBHOOK_FIELD_DATA_TYPES.CTA },
];

export const getSourceFromDataType = dataType => {
  if (dataType === WEBHOOK_FIELD_DATA_TYPES.ENRICHMENT) {
    return WEBHOOK_FIELD_SOURCES.ENRICHMENT;
  }

  return WEBHOOK_FIELD_SOURCES.CTA;
};

export const getDataTypeFromSource = source => {
  if (source === WEBHOOK_FIELD_SOURCES.ENRICHMENT) {
    return WEBHOOK_FIELD_DATA_TYPES.ENRICHMENT;
  }

  return WEBHOOK_FIELD_DATA_TYPES.CTA;
};

export const getContentTypeForBodyType = bodyType =>
  CONTENT_TYPE_BY_BODY_TYPE[bodyType] || CONTENT_TYPE_BY_BODY_TYPE[WEBHOOK_BODY_TYPES.JSON];

export const buildTestPayloadFromTemplate = template => {
  const payload = {};

  template.forEach(({ key, dataType }) => {
    if (!key) {
      return;
    }

    if (dataType === WEBHOOK_FIELD_DATA_TYPES.ENRICHMENT) {
      payload[key] = '<system_value>';
      return;
    }

    payload[key] = '<user_input>';
  });

  return JSON.stringify(payload, null, 2);
};

export const buildMockTestPayload = buildTestPayloadFromTemplate;

export default webhookData;
